export const toPercent = (value: number | null | undefined): number | null =>
   value == null ? null : value * 100;

export const fromPercent = (value: number | null | undefined): number | null =>
   value == null ? null : value / 100;

export const normalizePercentage = (value: number | null | undefined): number | undefined => {
   if (value == null) return undefined;
   if (!Number.isFinite(value)) return undefined;
   return fromPercent(value) ?? undefined;
};

export const formatDate = (date: string | Date | null | undefined, format: 'iso' | 'local' | 'datetime' = 'local'): string | undefined => {
   if (!date) return undefined;
   try {
      const dateObj = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(dateObj.getTime())) return undefined;
      if (format === 'iso') return dateObj.toISOString();
      if (format === 'datetime') {
         return `${dateObj.toLocaleDateString('sv-SE')} ${dateObj.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' })}`;
      }
      return dateObj.toLocaleDateString('sv-SE');
   } catch {
      return undefined;
   }
};

// Numbers up to 9999 are rendered without a separator by intentional product
// purley a design choice, to avoid unnecessary separators in small numbers and to keep the UI cleaner.
const LOCALE_FORMAT_THRESHOLD = 9999;
export const thousandSeparator = (x: number): string => {
   if (x > LOCALE_FORMAT_THRESHOLD || x < -LOCALE_FORMAT_THRESHOLD) {
      return x.toLocaleString('sv-SE');
   }
   return x.toString();
};

export const formatNumber = (value: number | null, options?: { suffix?: string }): string => {
   if (value === null) return '-';
   const rounded = Math.round(value * 100) / 100;
   const str = rounded.toFixed(2).replace(/\.?0+$/, '');
   return options?.suffix ? `${str}${options.suffix}` : str;
};

export const formatRoundedPercentage = (value: number | null | undefined): string => {
   if (value === null || value === undefined || !Number.isFinite(value)) return '-';
   return `${Math.round(value)}%`;
};

export const pluralize = (count: number, singular: string = 'item', plural?: string): string => {
   const pluralForm = plural || `${singular}s`;
   return `${count.toLocaleString()} ${count === 1 ? singular : pluralForm}`;
};

export const isUpdatedByOrAt = (accessor: string): boolean => {
   return accessor === 'updatedBy' || accessor === 'updatedAt';
};

export const parseNumericValue = (value: unknown): number => {
   if (typeof value === 'number') return isNaN(value) ? 0 : value;
   if (typeof value === 'string') return parseFloat(value) || 0;
   return 0;
};

export const normalizeNumericValue = (value: number | null | undefined): number => value ?? 0;
